import apiClient from '@u/apiClient'
import original_state from './original_state'
import Functionality from '@/plugins/functionality'
import GetInitialMetadatas from '@/wayfinder/actions/App/Http/Controllers/Metadata/GetInitialMetadatas'
import GetAllCorporationController from '@/wayfinder/actions/App/Http/Controllers/Metadata/GetAllCorporationController'
import GetScreenMetadataController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenMetadataController'
import UpdateVersionNoteController from '@/wayfinder/actions/App/Http/Controllers/VersionNote/UpdateVersionNoteController'

export default {
  fetchAllMetadata({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInitialMetadatas.getAll.get())
        .then((response) => {
          // await commit('setAllMetadata', response.data)
          commit(
            'dashboard/setFullColumnList',
            response.data.models.dashboard_columns,
            { root: true }
          )
          commit(
            'dashboard/setTemplateList',
            response.data.models.dashboard_templates,
            { root: true }
          )
          commit(
            'dashboard/setTemplate',
            response.data.models.dashboard_templates.find(
              (template) => template.is_default
            ),
            { root: true }
          )
          commit('setInitialMetadata', response.data)
          Functionality.setupModule(response.data.app_settings.functionalities)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getAllCorporations({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAllCorporationController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchMetadataScreen({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenMetadataController.get())
        .then((response) => {
          commit('setInitialMetadata', response.data)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchUsersMetadata({ commit }) {
    await apiClient
      .get('/api/metadata/users')
      .then(async (response) => {
        await commit('setUsersMetadata', response.data)
      })
      .catch(async (reason) => {
        console.error('fetchUsersMetadata', reason)
      })
  },
  async refreshInitialMetadataModels({ commit }) {
    await apiClient
      .route(GetInitialMetadatas.refreshModel.get())
      .then(async (response) => {
        // await console.log('refreshInitialMetadataModels', response)
        commit('setMetadataModels', response.data.models)
      })
      .catch(async (reason) => {
        await console.error('refreshInitialMetadataModels', reason)
      })
  },
  async refreshSpecificInitialMetadataModels({ commit }, payload) {
    return apiClient
      .route(
        GetInitialMetadatas.refreshModel.get({ query: { key: payload.model } })
      )
      .then(async (response) => {
        await commit('setSpecificMetadataModels', {
          model: payload.model,
          data: response.data[payload.model]
        })

        return response.data
      })
      .catch(async (reason) => {
        console.error('refreshInitialMetadataModels', reason)
      })
  },
  refreshSettingsMetadata({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInitialMetadatas.refreshSettings.get())
        .then((response) => {
          commit('setMetadataSettings', {
            settings: response.data.settings,
            fh_settings: response.data.fh_settings
          })
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async refreshMultipleInitialMetadataModels({ commit }, arrayOfModelsName) {
    await apiClient
      .route(
        GetInitialMetadatas.refreshModel.get({
          query: { key: arrayOfModelsName.join(',') }
        })
      )
      .then(async (response) => {
        // await console.log('refreshInitialMetadataModels', response)
        commit('setMutlipleMetadataModels', response.data)
      })
      .catch(async (reason) => {
        await console.error('refreshInitialMetadataModels', reason)
      })
  },

  async addReadVersionNote({ commit }, payload) {
    await apiClient
      .route(UpdateVersionNoteController.put(), payload.versions)
      .then(async (response) => {
        if (response.status === 200) {
          payload.successCallback()
        }
      })
      .catch(async (reason) => {
        console.error('updateInvoice reason', reason)
      })
  },
  resetState({ commit }) {
    commit('resetState', original_state)
  },
  setCurrentGlobalForm({ commit, state }, payload) {
    // console.log('setCurrentGlobalForm')
    // console.log('updateFormConfigSettings')
    // console.log(state.initialMetadata.form_settings[payload.funeral_home_id])
    // console.log('updateFormConfigFuneralHomeId')
    // console.log(payload.funeral_home_id)
    commit(
      'updateFormConfigSettings',
      state.initialMetadata.form_settings[payload.funeral_home_id]
    )
    commit('updateFormConfigFuneralHomeId', payload.funeral_home_id)
  },
  toggleGlobalFormEditionModeForFuneralHome({ commit, state }, payload) {
    commit(
      'updateFormConfigSettings',
      state.initialMetadata.form_settings[payload.funeral_home_id]
    )
    commit('updateFormConfigFuneralHomeId', payload.funeral_home_id)
    commit('toggleGlobalFormEditionMode', true)
  },
  restoreGlobalForm({ commit, state }, payload) {
    if (state.global_form.funeral_home_id !== payload.funeral_home_id) {
      commit(
        'updateFormConfigSettings',
        state.initialMetadata.form_settings[payload.funeral_home_id]
      )
      commit('updateFormConfigFuneralHomeId', payload.funeral_home_id)
    }
  },
  commitFormSettingToInitialMetadata({ commit, state }, payload) {
    state.initialMetadata.form_settings[payload.funeral_home_id] =
      payload.form_settings
  },
  //  USER STATUS
  changeUserOnlineStatus({ commit }, payload) {
    commit('changeUserOnlineStatus', payload)
  }
}
